<template>
  <plantilla-contenido>
    <div slot="titulo">
      <i class="fas fa-home icon"></i>
      Inicio
    </div>
    <div slot="breadCrumb">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link :to="{ name: 'directiveReport' }">
              <span class="has-text-black">
                <i class="fas fa-home icon"></i>
                inicio
              </span>
            </router-link>
          </li>
          <li class="is-active">
            <router-link :to="{ name: 'directiveReport' }">
              <span class="has-text-black">
                <i class="fas fa-bed"></i>
                Reporte
              </span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div slot="contenido">
      <div class="box" style="min-height: 500px">
        <b-tabs type="is-boxed">
            <b-tab-item label="Estado de camas" icon="table">
              <state-bed-report></state-bed-report>
            </b-tab-item>
            <b-tab-item label="Reporte diario" icon="calendar-alt">
              <daily-reports-table :hideButton="true"></daily-reports-table>
            </b-tab-item>
            <b-tab-item label="Covid" icon="virus">
              <report-patient></report-patient>  
            </b-tab-item>
            <b-tab-item label="historial de cambios" icon="book">
              <history-changes></history-changes>
            </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </plantilla-contenido>
</template>
<script>

import PlantillaContenido from "../../template/PlantillaContenido";
import ReportPatient from '../../components/reports/ReportPatient.vue';
import StateBedReport from '../../components/reports/StateBedReport.vue';
import DailyReportsTable from '../../components/reports/DailyReportsTable.vue';
import HistoryChanges from '../../components/reports/HistoryChanges.vue';
export default {
  components: {
    PlantillaContenido,
    ReportPatient,
    StateBedReport,
    DailyReportsTable,
    HistoryChanges,
  },
  data() {
    return {};
  },

  methods: {
  },
};
</script>